import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import {
  openConfirmToggle,
  openFormModal,
  openViewModal,
} from "../../store/reducers/plantels/plantels.reducer";
import { getPlantelByIdThunk } from "../../store/reducers/plantels/plantels.thunks";
import { Link } from "react-router-dom";

const PlantelActions = ({ plantel }) => {
  const dispatch = useDispatch();
  // console.log(plantel.id)
  const handleView = () => {
    dispatch(openViewModal());
    dispatch(getPlantelByIdThunk(plantel.id));
  };

  const handleEdit = async () => {
    // Obtener los detalles completos del plantel primero
    await dispatch(getPlantelByIdThunk(plantel.id));
    dispatch(openFormModal({ mode: "edit" }));
  };

  const handleToggle = () => {
    dispatch(openConfirmToggle({ id: plantel.id }));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${plantel.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                plantel.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{plantel.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
        <li>
          <Link className={itemClass} to={`/ver-talentos/${plantel.id}`}>
            <Icon icon="mdi:cog-outline" width="18" />
            <span>Ver configuración de talentos</span>
          </Link>
        </li>
        <li>
          <Link
            className={itemClass}
            to={`/ver-confirmación-talentos/${plantel.id}`}
          >
            <Icon icon="mdi:brain" width="18" />
            <span>Ver confirmación de talentos</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default PlantelActions;
